import ActionTypes from './types';

export const handleAuthState = (name, value) => ({
    type: ActionTypes.HANDLE_AUTH,
    payload: {
        name,
        value
    }
});